import React from "react";

function MobileFooter() {
  return (
    <div className="sub__footer__container">
      <div>Follow us on</div>
      <div className="social__icons">
        <div>
          <i className="fa fa-instagram"></i>
        </div>
        <div>
          <i className="fa fa-facebook-square"></i>
        </div>
        <div>
          <i className="fa fa-linkedin"></i>
        </div>
      </div>
      <div>Copyright © 2021 Marketplace by STPI</div>
    </div>
  );
}

export default MobileFooter;
